import type { LeaseActionProps } from '../../../models/Types';
import ArchiveLeaseModal from '../../ArchiveLeaseModal';

export default function OpenModalArchiveLease({ lease, terminateActiveAction }: LeaseActionProps) {
  return <ArchiveLeaseModal onClose={terminateActiveAction} lease={lease} />;
}
